import { h } from 'preact';

/**
 * DecorativeImage is a component that renders an image with an
 * empty alt attribute and a role of presentation, to be in compliance
 * with accessibility standards for decorative images.
 * NOTE: all other passed in props are respected
 */
const DecorativeImage = (props) => {
  // remove alt and role from props passed in
  const { alt, role, ...restProps } = props;
  // use these for alt and role, instead of the ones passed in
  const decorativeImageAttributes = {
    alt: '', // empty alt tag for decorative images
    role: 'presentation', // screen readers also like presentation role
  };
  return <img alt={decorativeImageAttributes.alt} role={decorativeImageAttributes.role} {...restProps} />;
};

export default DecorativeImage;
